/**
 * OmeBio — Cinematic Scroll Animation System
 * Ported from the Astro site. Smooth, restrained, mathematically precise.
 */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. HEADER SCROLL EFFECT
  var header = document.getElementById('siteHeader');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 40) {
      header && header.classList.add('scrolled');
    } else {
      header && header.classList.remove('scrolled');
    }
  }, { passive: true });

  // 2. HERO WORD-BY-WORD REVEAL
  var heroH1 = document.querySelector('.hero-manifesto h1');

  if (heroH1 && !prefersReduced) {
    var heroLines = heroH1.querySelectorAll('.hero-line');
    var wordIndex = 0;

    heroLines.forEach(function (lineEl) {
      var text = lineEl.textContent || '';
      var words = text.trim().split(/\s+/);
      lineEl.innerHTML = '';

      words.forEach(function (word, i) {
        var span = document.createElement('span');
        span.className = 'word';
        span.textContent = word;
        span.style.transitionDelay = (wordIndex * 0.06) + 's';
        lineEl.appendChild(span);
        wordIndex++;

        if (i < words.length - 1) {
          var space = document.createElement('span');
          space.className = 'word-space';
          lineEl.appendChild(space);
        }
      });
    });

    requestAnimationFrame(function () {
      setTimeout(function () {
        heroH1.querySelectorAll('.word').forEach(function (w) {
          w.classList.add('visible');
        });
      }, 200);
    });
  } else if (heroH1) {
    heroH1.style.opacity = '1';
  }

  // 3. HERO BODY REVEAL
  var heroBody = document.querySelector('.hero-body');
  if (heroBody && !prefersReduced) {
    var wordCount = heroH1 ? heroH1.querySelectorAll('.word').length : 0;
    var bodyDelay = 200 + (wordCount * 60) + 300;
    setTimeout(function () {
      heroBody.classList.add('visible');
    }, bodyDelay);
  } else if (heroBody) {
    heroBody.classList.add('visible');
  }

  // 4. INTERSECTION OBSERVERS
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
  });

  var clipObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        clipObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.06,
    rootMargin: '0px 0px -30px 0px'
  });

  var footerObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        footerObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  document.querySelectorAll('.reveal, .stagger, .rule').forEach(function (el) {
    revealObserver.observe(el);
  });

  document.querySelectorAll('.reveal-clip').forEach(function (el) {
    clipObserver.observe(el);
  });

  document.querySelectorAll('.site-footer').forEach(function (el) {
    footerObserver.observe(el);
  });

  // 5. PILLAR CARD 3D TILT
  document.querySelectorAll('.pillar').forEach(function (card) {
    var maxTilt = 3;

    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      var rotateX = (0.5 - y) * maxTilt * 2;
      var rotateY = (x - 0.5) * maxTilt * 2;
      card.style.transform = 'perspective(600px) rotateX(' + rotateX.toFixed(1) + 'deg) rotateY(' + rotateY.toFixed(1) + 'deg) translateZ(0)';
    });

    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(600px) rotateX(0) rotateY(0) translateZ(0)';
      card.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
      setTimeout(function () { card.style.transition = ''; }, 500);
    });

    card.addEventListener('mouseenter', function () {
      card.style.transition = 'none';
    });
  });

  // 6. CREDENTIAL CARD HOVER
  document.querySelectorAll('.cred-item').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      item.style.transform = 'translateY(-3px)';
    });
    item.addEventListener('mouseleave', function () {
      item.style.transform = 'translateY(0)';
    });
  });

  // 7. MAGNETIC BUTTON
  document.querySelectorAll('.btn').forEach(function (btn) {
    var inner = btn.querySelector('.btn-inner') || btn;
    var strength = 0.3;

    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      inner.style.transform = 'translate(' + (x * strength) + 'px, ' + (y * strength) + 'px)';
    });

    btn.addEventListener('mouseleave', function () {
      inner.style.transform = 'translate(0, 0)';
    });
  });

})();
